export default "__VITE_ASSET__caa7393c__"